import './studio.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from "@material-ui/core/Typography";
import { useRef, useEffect, useState } from "react";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import StudioContent from './studioContent';
import AephoriaLogo from "../images/Aephoria-logo-blue.png"
import * as aserver from '../../APIClient';
import WhiteLogo from "../images/AIM Leaf Inverted.png"
const axios = require('axios').default;

let observer = null;

function changeLanguage(language) {
    window.location.href = "https://" + window.location.host + window.location.pathname + '?language=' + language;
}

const LanguageSwitch = (props) => {
    let selected = '';
    if (props.reportLanguage === props.language)
        selected = 'selected';
    return (<span className={`languageSwitch ${selected}`} style={{ cursor: "pointer" }} onClick={() => changeLanguage(props.language)}>{props.display} </span>)
}

const LanguageSwitchPanel = (props) => {
    if ((props.assessmentType === 'EIT') || (props.assessmentType === 'full'))
        return (<></>);
    return (<div className="headerDiv">
        <p>Language: </p>
        <LanguageSwitch language='hungarian' display='Hungarian' reportLanguage={props.reportLanguage} />
        <LanguageSwitch language='slovak' display='Slovak' reportLanguage={props.reportLanguage} />
        <LanguageSwitch language='english' display='English' reportLanguage={props.reportLanguage} />
    </div>);
}

const Copyright = () => {
    return (<div style={{ width: '100%', textAlign: 'center', marginTop: '2em', marginBottom: '2em' }}>Aephoria Copyright 2011-{new Date().getFullYear()}</div>)
}

const MenuBar = (props) => {
    return (<Typography onClick={props.onMenuClick} style={{ position: 'fixed', right: '1em', top: '1em' }}>
        {props.showMenu ? <CloseIcon /> : <MenuIcon />}
    </Typography >);
}

const StudioMenu = (props) => {
    return (<nav className='studioMenu' aria-hidden='true'>
        {props.tabs.map((tab, index) => {
            let classNames = [`studioTab`];
            classNames.push(`${(props.selectedTab && (props.selectedTab.id === tab.id)) ? 'selected' : ''}`);
            classNames.push(tab.isSection ? 'tabSection' : '');
            return (
                <div key={index} className={classNames.join(' ')} onClick={() => props.onTabClicked(tab)} >
                    {tab.name}
                </div>
            )
        })}
    </nav>)
}

const DrawerTabs = (props) => {
    return (<div className='drawer'>
        {props.tabs.map((tab, index) => {
            let classNames = [`studioTab`];
            classNames.push(`${(props.selectedTab && (props.selectedTab.id === tab.id)) ? 'selected' : ''}`);
            classNames.push(tab.isSection ? 'tabSection' : '');
            return (
                <div key={index} className={classNames.join(' ')} onClick={() => props.onTabClicked(tab)}>
                    {tab.name}
                </div>
            )
        })}
    </div>)
}

const ClientReports = (props) => {
    // https://localhost:3100/coachportal/reports/5b06e420-fa40-11e9-a6df-3d800e1851d3
    //https://localhost:3100/coachportal/reports/basic/22627260-a613-11ed-a994-75b59d0b7741
    const pathparts = window.location.pathname.split('/');
    const assessmentUUID = pathparts[pathparts.length - 1];
    const reportCode = props.legacy?'e':pathparts[pathparts.length - 2];
    const urlParams = new URLSearchParams(window.location.search);
    const requestedLanguage = urlParams.get('language');
    const requestedVersion = urlParams.get('version');
    const requestedTrifix = urlParams.get('trifix');
    const requestedInstinct = urlParams.get('instinct');
    const notEnglish = requestedLanguage&&(requestedLanguage!=='english')
    const reportName = {
        e: 'Enneagram',
        m: 'Maturity',
        c: 'Combined',
        cp: 'Combined+'
    }[reportCode]+' Report';



    function getIsNarrow() {
        if (onlyText)
            return (true)
        else
            return (window.innerWidth < 800);
    }

    const [isNarrow, setIsNarrow] = useState(getIsNarrow());
    const [onlyText, setOnlyText] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [mini, setMini] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsNarrow(getIsNarrow());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [onlyText]);


    const studioRef = useRef(null);
    const [selectedTab, setSelectedTab] = useState(null);
    const [results, setResults] = useState(null);
    const [tabs, setTabs] = useState([]);
    const [refresher, setRefresher] = useState(null);


    function tabsReady(_tabs) {
        setTabs(_tabs);
        let initialTab = _tabs.find(t => (t.id === localStorage.getItem('selectedTabId'))) || _tabs[1];
        setSelectedTab(initialTab);
        /*
        observer = new IntersectionObserver((entries, observer) => {
            console.log(entries);
            entries.sort((a,b)=>b.intersectionRatio-a.intersectionRatio);
            console.log(entries);
            for (let entry of entries) {
                if (entry.isIntersecting) {
                    console.log('#### intersecting',entry.target.id,'######')
                    console.log(_tabs.length)
                    let tab = _tabs.find(t=>t.id===entry.target.id);
                    if ((tab)&&(!tab.isCategory)) {
                        tabHighlight(tab);
                        console.log('#### highlight',entry.target.id,'######')
                    }
                    break;
                }
            }
              // Each entry describes an intersection change for one observed
              // target element:
              //   entry.boundingClientRect
              //   entry.intersectionRatio
              //   entry.intersectionRect
              //   entry.isIntersecting
              //   entry.rootBounds
              //   entry.target
              //   entry.time
        }, {
            root: document.querySelector("#studioWideContent"),
            rootMargin: "30px",
            threshold: 0.1,
          });
          console.log(observer.root);
        */

    }

    function showContent() {
        let s = [];
        for (let t of tabs) {
            s.push(<div id={t.id}><h2>{t.name}</h2>{t.content}</div>)
        }

        /*
        window.requestAnimationFrame(() => {
            for (let tab of tabs) {
                if (observer)
                    observer.observe(document.querySelector('#' + tab.id))
            }
        });
        */


        return (s.map((c, index) => <div key={index}>{c}</div>));
    }

    function scrollToTop() {
        window.requestAnimationFrame(() => {
            studioRef.current.scrollIntoView();//{behavior: "smooth", block: "start", inline: "nearest"})
        });
    }

    function tabHighlight(tab) {
        setSelectedTab(tab);
        setRefresher((new Date()).getTime());
    }

    function tabClicked(tab) {
        if (showMenu)
            setShowMenu(!showMenu);
        setSelectedTab(tab);
        setRefresher((new Date()).getTime());
        scrollToTop();
        if (tab.onClick) {
            tab.onClick();
            return;
        }
        localStorage.setItem('selectedTabId', tab.id);

        console.log('scrolling to id=', tab.id)
        window.requestAnimationFrame(() => {
            document.getElementById(tab.id).scrollIntoView();//{behavior: "smooth", block: "start", inline: "nearest"})
        });

    }

    useEffect(() => {
        async function getResults() {
            try {
                const response = await axios.get(
                    `${aserver.getServerRoot()}/${`api/v2/guestresults/${assessmentUUID}`}?reportCode=${reportCode}&language=${requestedLanguage}&trifix=${requestedTrifix}&instinct=${requestedInstinct}&version=${requestedVersion}&t=${+ new Date()}`
                );
                if ((response.data) && (response.data.error)) {
                    window.alert(response.data.error);
                    return;
                }
                //console.log('GETRESULTS:', response.data);
                setResults(response.data);
                if (response.data.onlyText) {
                    setIsNarrow(true);
                    setOnlyText(true);
                }
                setMini(response.data.guest.miniGuest);
            } catch (err) {
                console.log(err)
            }
        };
        studioRef.current.focus();
        getResults();
    }, [assessmentUUID]);

    
    let htmlContent = !results?<></>:<StudioContent
        reportContent={results.reportContent}
        assessment={results.guest}
        results={results}
        onTabsReady={tabsReady}
        refresher={refresher}
        isNarrow={isNarrow}
        reportCode={reportCode}
        reportName = {reportName}
        notEnglish={notEnglish}
        reportLanguage={requestedLanguage}
        assessmentName = {results.guest.assessmentTypeName}
    />

    return (<>
        <CssBaseline />
        <div ref={studioRef} className='studioContainer'>
            {!results ? <>Loading...</> : <>
                {isNarrow && !mini && <div className="containerNarrow">
                    {!onlyText && <MenuBar showMenu={showMenu} onMenuClick={() => setShowMenu(!showMenu)} />}
                    <div className={'studioNarrow'}>
                        {!onlyText && <div>
                            <img className="navLogo" style={{ textAlign: 'center' }} src={AephoriaLogo} alt="aephoria-logo" />
                        </div>}
                        {!onlyText && htmlContent}
                        {showMenu && !onlyText && <StudioMenu onTabClicked={tabClicked} selectedTab={selectedTab} tabs={tabs} />}
                        {selectedTab &&
                            <div role="main">
                                <div>{showContent()}</div>
                                <Copyright />
                            </div>}
                    </div>
                </div>}
                {((!isNarrow) || mini) && <div className="containerWide">
                    {true&&<div className={'header' + (mini ? ' mini' : '')}>
                        {htmlContent}
                        <img className="aephoriaLogoStudio" src={WhiteLogo} alt="aephoria-logo" />
                        {<div className="headerInformation">
                            <h2>{mini?results.guest.assessmentTypeName:reportName}</h2>
                            <p><b>{results.guest.userName} {results.guest.userSurname}</b></p>
                            <p>{results.guest.userEmail}</p>
                            <p>{results.guest.completedAt.substring(0, 10)}</p>
                            {mini ? <LanguageSwitchPanel className="headerDiv" reportLanguage={results.guest.reportLanguage} assessmentType={results.guest.assessmentType} /> : ""}
                        </div>}
                    </div>}
                    {!mini && <nav id="navDrawer" aria-hidden='true'><DrawerTabs onTabClicked={tabClicked} selectedTab={selectedTab} tabs={tabs} /> </nav>}
                    <div className={'studioWide' + (mini ? ' mini' : '')}>
                        {selectedTab &&
                            <div id='studioWideContent' className='studioWideContent' role="main">
                                <div>{showContent()}</div>
                                <Copyright />
                            </div>}
                    </div>
                </div>}
            </>}
        </div>
    </>)

};

export default ClientReports;
